import { Navigate } from 'react-router-dom';
import { useFeatureFlags } from '@/contexts/FeatureFlagContext';
import { FeatureFlags } from '@/types/feature-flags.types';

interface FeatureRouteProps {
  /** Flag(s) the route needs; with several, every one must be on. */
  feature: keyof FeatureFlags | readonly (keyof FeatureFlags)[];
  children: React.ReactNode;
  redirectTo?: string;
}

export function FeatureRoute({
  feature,
  children,
  redirectTo = '/dashboard',
}: FeatureRouteProps) {
  const flags = useFeatureFlags();
  const required: readonly (keyof FeatureFlags)[] = typeof feature === 'string' ? [feature] : feature;
  const isEnabled = required.every((f) => !!flags[f]);

  if (!isEnabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
